module.exports = __webpack_public_path__ + "img/8.b6a6ddb5.jpg";